import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { BrandLoader } from "@/components/BrandLoader";

export default function AuthCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await apiClient.post("/auth/google/session", { session_id });
        setUser(data);
        navigate("/", { replace: true });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh]">
      <BrandLoader message={t("common.loggingIn")} />
    </div>
  );
}
